import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './component.scss'

const SELECTORS = {
  areaMenuRoot: '.js-areaMenu-root',
  prefectureTrigger: '.js-openPrefecture-trigger',
  prefectureTarget: '.js-openPrefecture-target',
  triangleItem: '.area-menu__prefecture-item-triangle'
}

const CLASS_NAMES = {
  regionItemActive: 'area-menu__region-item--active',
  prefectureGroupActive: 'area-menu__prefecture-group--active',
  areaMenuActive: 'area-menu--active',
  triangleHover: 'area-menu__region-item--triangle-hover'
}

function AreaMenu() {
  const resetAllActiveStates = () => {
    const triggers = document.querySelectorAll(SELECTORS.prefectureTrigger)
    const targets = document.querySelectorAll(SELECTORS.prefectureTarget)
    const root = document.querySelector(SELECTORS.areaMenuRoot)

    triggers.forEach(trigger => trigger.classList.remove(CLASS_NAMES.regionItemActive))
    targets.forEach(target => target.classList.remove(CLASS_NAMES.prefectureGroupActive))
    if (root) {
      root.classList.remove(CLASS_NAMES.areaMenuActive)
    }
  }

  const activateElements = (trigger, target, root) => {
    trigger.classList.add(CLASS_NAMES.regionItemActive)
    if (target) {
      target.classList.add(CLASS_NAMES.prefectureGroupActive)
    }
    if (root) {
      root.classList.add(CLASS_NAMES.areaMenuActive)
    }
  }

  const handleTriggerMouseEnter = (event) => {
    const trigger = event.currentTarget
    const regionId = trigger.dataset.regionId
    const root = trigger.closest(SELECTORS.areaMenuRoot)
    const target = root?.querySelector(`${SELECTORS.prefectureTarget}[data-region-id="${regionId}"]`)

    resetAllActiveStates()
    activateElements(trigger, target, root)
  }

  const handleTriangleHover = (isEnter) => {
    const activeTrigger = document.querySelector(`${SELECTORS.prefectureTrigger}.${CLASS_NAMES.regionItemActive}`)
    if (activeTrigger) {
      activeTrigger.classList.toggle(CLASS_NAMES.triangleHover, isEnter)
    }
  }

  const init = () => {
    const triggers = document.querySelectorAll(SELECTORS.prefectureTrigger)
    const triangles = document.querySelectorAll(SELECTORS.triangleItem)

    triggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', handleTriggerMouseEnter)
    })

    triangles.forEach(triangle => {
      triangle.addEventListener('mouseenter', () => handleTriangleHover(true))
      triangle.addEventListener('mouseleave', () => handleTriangleHover(false))
    })
  }

  return { init }
}

document.addEventListener('DOMContentLoaded', () => {
  const areaMenu = AreaMenu()
  areaMenu.init()
})
